import React from "react";
import Button from "components/base/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faCalculator } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { themeColors } from "./ProductAttributeFieldStyles";

interface ProductHeaderProps {
  loading: boolean;
  onClear: () => void;
  onSaveDraft: () => void;
  onPublish: () => void;
  onCalculateCommission?: () => void;
  canCalculateCommission?: boolean;
}

const ProductHeader: React.FC<ProductHeaderProps> = ({
  loading,
  onClear,
  onSaveDraft,
  onPublish,
  onCalculateCommission,
  canCalculateCommission = false,
}) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  return (
    <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
      <div>
        <h2
          className="mb-2"
          style={{ textAlign: isArabic ? "right" : "left" }}
        >
          {t("addProductTitle")}
        </h2>
      </div>
      <div className="d-flex flex-wrap gap-2">
        <Button
          variant="phoenix-secondary"
          type="button"
          onClick={onClear}
        >
          {t("clear")}
        </Button>
        
        {/* Uncomment if save draft functionality is needed
        <Button
          variant="phoenix-primary"
          type="button"
          onClick={onSaveDraft}
          style={{ opacity: loading ? 0.5 : 1 }}
        >
          <FontAwesomeIcon
            icon={faFloppyDisk}
            style={{ marginRight: "8px" }}
          />
          {t("saveDraft")}
        </Button>
        */}
        
        {/* Commission Calculation Button */}
        {onCalculateCommission && (
          <Button
            variant="info"
            type="button"
            onClick={onCalculateCommission}
            disabled={!canCalculateCommission}
            style={{ 
              backgroundColor: canCalculateCommission ? '#17a2b8' : '#6c757d', 
              borderColor: canCalculateCommission ? '#17a2b8' : '#6c757d',
              color: '#fff'
            }}
          >
            <FontAwesomeIcon icon={faCalculator} className="me-2" />
            {t("products.commission.calculateCommission")}
          </Button>
        )}
        
        <Button
          variant="primary"
          type="button"
          onClick={onPublish}
          disabled={loading}
          style={{ 
            backgroundColor: themeColors.orange, 
            borderColor: themeColors.orange,
            color: '#fff'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = themeColors.darkOrange;
            e.currentTarget.style.borderColor = themeColors.darkOrange;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = themeColors.orange;
            e.currentTarget.style.borderColor = themeColors.orange;
          }}
        >
          {loading ? (
            <>
              <span 
                className="spinner-border me-2" 
                role="status" 
                aria-hidden="true"
                style={{ 
                  width: "0.8rem", 
                  height: "0.8rem", 
                  borderWidth: "0.1em" 
                }}
              ></span>
              {t("publishing")}
            </>
          ) : (
            t("publishProduct")
          )}
        </Button>
      </div>
    </div>
  );
};

export default ProductHeader;
